import Vue from "vue";

import BN from "bignumber.js";
import { config } from "../../config";

export const gasPriceOracles = {
  1: 'https://blockscout.com/eth/mainnet/api/v1/gas-price-oracle',
  137: 'https://gasstation-mainnet.matic.network',
  80001: 'https://gasstation-mumbai.matic.today'
}

export const gasPriceOracle = gasPriceOracles[config.network.chainId]

export const state = Vue.observable({
  fetched: false,
  gasPriceInfo: {},
  gasPrice: 20,
  gasPriceWei: "20000000000",
  gasPriceInterval: null,
});
